import React from 'react';

const ThemeContext = React.createContext({
  setTheme: () => {}
});

export default ThemeContext;
